// extracted by mini-css-extract-plugin
export default {"container":"QIepK","wrapper":"KeNJ_","textContainer":"gcBrq","totalCollected":"wMehO","description":"N8tcO","tva":"SNBjZ","rightImage":"EhzpA","leftImage":"s24sB"};